'use strict';

exports.__esModule = true;
exports.default = exports.getWindowWidth = exports.getDeviceInfo = exports.getDeviceName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _media = require('./../../styles/mixins/media');

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDeviceName = exports.getDeviceName = function getDeviceName(width) {
  switch (true) {
    case width < _media.sizes.phone:
      return 'phone';
    case width < _media.sizes.tablet:
      return 'tablet';
    case width < _media.sizes.desktop:
      return 'desktop';
    default:
      return 'giant';
  }
};

var getDeviceInfo = exports.getDeviceInfo = (0, _memoize2.default)(function (device) {
  return Object.keys(_media.sizes).reduce(function (deviceInfo, deviceName) {
    deviceInfo['is' + deviceName[0].toUpperCase() + deviceName.substr(1)] = device === deviceName;
    return deviceInfo;
  }, {});
});

var getWindowWidth = exports.getWindowWidth = function getWindowWidth() {
  return Math.max(document.documentElement.clientWidth, document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth);
};

var DeviceInfo = (_temp2 = _class = function (_Component) {
  _inherits(DeviceInfo, _Component);

  function DeviceInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeviceInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeviceInfo.__proto__ || Object.getPrototypeOf(DeviceInfo)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      deviceInfo: getDeviceInfo(getDeviceName(getWindowWidth()))
    }, _this.updateWidth = (0, _debounce2.default)(function () {
      var deviceInfo = _this.state.deviceInfo;

      var newDeviceInfo = getDeviceInfo(getDeviceName(getWindowWidth()));
      if (newDeviceInfo !== deviceInfo) {
        _this.setState({ deviceInfo: newDeviceInfo });
      }
    }, 100, { maxWait: 100 }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeviceInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateWidth);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWidth);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.state.deviceInfo);
    }
  }]);

  return DeviceInfo;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = DeviceInfo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/utils/device-info/device-info.js
// module id = 1003
// module chunks = 0